<template>
	<div ref="carouselContainer" class="overflow-hidden relative">
		<div
			class="absolute left-0 inset-y-0 w-56 bg-gradient-to-l from-black/0 to-black z-10"
		></div>
		<div
			ref="carouselContent"
			class="flex justify-center gap-40 [:not(.carousel-static)_*]:relative [:not(.carousel-static)_*]:-left-[5.75rem]"
			:class="{ 'carousel-move': isCarousel, 'carousel-static': !isCarousel }"
		>
			<template v-if="isCarousel">
				<slot></slot>
			</template>
			<div ref="carouselInitial" class="flex justify-center gap-40">
				<slot></slot>
			</div>
			<template v-if="isCarousel">
				<slot></slot>
			</template>
			<template v-if="isCarousel">
				<slot></slot>
			</template>
		</div>
		<div
			class="absolute right-0 inset-y-0 w-56 bg-gradient-to-r from-black/0 to-black z-10"
		></div>
	</div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import { onResize } from "@js/throttle.js"

const isCarousel = ref(false);
const carouselContainer = ref(null);
const carouselContent = ref(null);
const carouselInitial = ref(null);

const checkCarousel = async () => {
	if (carouselContainer.value && carouselContent.value &&	carouselInitial.value) {
		const containerWidth = carouselContainer.value.getBoundingClientRect().width;
		const initialWidth = carouselInitial.value.getBoundingClientRect().width;

		isCarousel.value = initialWidth > containerWidth;
		carouselContent.value.style.setProperty("--carousel-width", `${initialWidth}px`);

		/* calculate animation speed dynamically so it is uniform regardless of the number of items in the carousel */
		const speed = 70; /* tweak this number to change carousel speed - higher = faster, lower = slower */
		carouselContent.value.style.setProperty("--carousel-duration", `${initialWidth / speed}s`);
	}
};

onMounted(() => {
	checkCarousel();
	onResize(checkCarousel);
});

onBeforeUnmount(() => {
	window.removeEventListener("resize", checkCarousel);
});
</script>

<style scoped>
.carousel-move {
	animation: carousel var(--carousel-duration) linear infinite;
}

@keyframes carousel {
	0% {
		transform: translateX(0%);
	}
	100% {
		transform: translateX(calc(-1 * var(--carousel-width) - theme(spacing.40)));
	}
}
</style>
